import React from 'react'
import {Variant} from '../types'
import {Badge} from 'react-bootstrap'

interface Props {
	data: Variant
}

const OtherVariant: React.FC<Props> = ({data}) => {
	return (
		<div style={{borderRadius: '4px'}} className={'bg-secondary-subtle m-1 p-1 d-flex align-items-center'}><Badge className='me-1' bg="primary">{data.lang}</Badge>{data.part_name}</div>
	)
}

export default OtherVariant